import { env } from "@/config/env";

const DEVICE_ID_KEY = "papaya-web-device-id";

export function getOrCreateDeviceId(): string {
  if (typeof window === "undefined") return "";
  try {
    const existing = localStorage.getItem(DEVICE_ID_KEY)?.trim();
    if (existing) return existing.slice(0, 64);
    const id =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? `web-${crypto.randomUUID()}`
        : `web-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(DEVICE_ID_KEY, id);
    return id.slice(0, 64);
  } catch {
    return `web-${Date.now()}`;
  }
}

export type VoipTokenPayload = {
  fcm_token: string;
  device_id: string;
  platform: "web";
  token_type: "FCM";
  sip_username?: string;
};

export function buildVoipLoginFields(token: string | null | undefined): Partial<VoipTokenPayload> {
  const fcm_token = String(token || "").trim();
  if (!fcm_token) return {};
  return {
    fcm_token,
    device_id: getOrCreateDeviceId(),
    platform: "web",
    token_type: "FCM",
  };
}

export function isFirebaseWebConfigured() {
  return Boolean(
    env.firebase.apiKey &&
      env.firebase.projectId &&
      env.firebase.appId &&
      env.firebase.messagingSenderId &&
      env.firebase.vapidKey,
  );
}
